/* eslint-disable */
import React from "react";
import Icon from "../Icon";
const GlyphSocialInstagram = props => {
  const {
    color,
    size,
    width,
    height,
    customColor,
    className,
    dataTest,
    ariaHidden,
    ariaLabel,
    reverseOnRtl
  } = props;
  return React.createElement(Icon, {
    viewBox: "0 0 16 16",
    size: size,
    width: width,
    height: height,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M8 2.753c1.708 0 1.911.006 2.586.037.728.033 1.404.18 1.924.7s.666 1.195.7 1.923c.03.675.036.878.036 2.587 0 1.708-.006 1.911-.037 2.586-.033.728-.179 1.404-.699 1.924s-1.196.666-1.924.7c-.675.03-.878.036-2.586.036-1.71 0-1.912-.006-2.587-.037-.728-.033-1.404-.179-1.924-.699s-.666-1.196-.699-1.924C2.76 9.91 2.753 9.708 2.753 8c0-1.71.006-1.912.037-2.587.033-.728.18-1.404.7-1.924s1.195-.666 1.923-.699c.675-.03.878-.037 2.587-.037zM8 1.6c-1.739 0-1.957.007-2.64.038-1.04.047-1.953.302-2.686 1.036-.734.733-.989 1.647-1.036 2.687-.03.682-.038.9-.038 2.639 0 1.738.007 1.956.038 2.639.047 1.04.302 1.953 1.036 2.687.733.733 1.647.988 2.687 1.035.682.031.9.039 2.639.039 1.738 0 1.956-.008 2.639-.039 1.04-.047 1.953-.302 2.687-1.036.733-.733.988-1.646 1.035-2.686.031-.683.039-.901.039-2.64 0-1.738-.008-1.956-.039-2.638-.047-1.04-.302-1.954-1.036-2.687-.733-.734-1.646-.989-2.686-1.036-.683-.03-.901-.038-2.64-.038z"
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M8 4.713a3.287 3.287 0 100 6.573 3.287 3.287 0 000-6.573zm0 5.42a2.133 2.133 0 110-4.267 2.133 2.133 0 010 4.267zm3.416-4.783a.768.768 0 100-1.535.768.768 0 000 1.535z"
  }));
};
export default GlyphSocialInstagram;